import { render, staticRenderFns } from "./RepairRelations.vue?vue&type=template&id=67988042&scoped=true&"
import script from "./RepairRelations.vue?vue&type=script&lang=js&"
export * from "./RepairRelations.vue?vue&type=script&lang=js&"
import style0 from "./RepairRelations.vue?vue&type=style&index=0&id=67988042&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67988042",
  null
  
)

export default component.exports